const texts = {
    "click-here": {
        EN: "Click here",
        DA: "Klik her",
        DE: "Hier klicken",
        NL: "Klik hier",
        FR: "Cliquez ici",
        IT: "Clicca qui",
        ES: "Haz clic aquí",
        PT: "Clique aqui",
        FI: "Klikkaa tästä",
        SV: "Klicka här",
    },
    yes: {
        EN: "Yes",
        DA: "Ja",
        DE: "Ja",
        NL: "Ja",
        FR: "Oui",
        IT: "Sì",
        ES: "Sí",
        PT: "Sim",
        FI: "Kyllä",
        SV: "Ja",
        NO: "Ja",
    },
    no: {
        EN: "No",
        DA: "Nej",
        DE: "Nein",
        NL: "Nee",
        FR: "Non",
        IT: "No",
        ES: "No",
        PT: "Não",
        FI: "Ei",
        SV: "Nej",
        NO: "Nei",
    },
    done: {
        EN: "Done",
        DA: "Færdig",
        DE: "Fertig",
        NL: "Klaar",
        FR: "Terminé",
        IT: "Fatto",
        ES: "Hecho",
        PT: "Feito",
        FI: "Valmis",
        SV: "Klar",
        NO: "Ferdig",
    },
    cancel: {
        EN: "Cancel",
        DA: "Annuller",
        DE: "Abbrechen",
        NL: "Annuleren",
        FR: "Annuler",
        IT: "Annulla",
        ES: "Cancelar",
        PT: "Cancelar",
        FI: "Peruuta",
        SV: "Avbryt",
        NO: "Avbryt",
    },
    submit: {
        EN: "Submit",
        DA: "Indsend",
        DE: "Absenden",
        NL: "Versturen",
        FR: "Soumettre",
        IT: "Invia",
        ES: "Enviar",
        PT: "Enviar",
        FI: "Lähetä",
        SV: "Skicka",
        NO: "Send",
    },
    free: {
        EN: "Free",
        DA: "Gratis",
        DE: "Kostenlos",
        NL: "Gratis",
        FR: "Gratuit",
        IT: "Gratuito",
        ES: "Gratis",
        PT: "Grátis",
        FI: "Ilmainen",
        SV: "Gratis",
        NO: "Gratis",
    },
    and: {
        EN: "and",
        DA: "og",
        DE: "und",
        NL: "en",
        FR: "et",
        IT: "e",
        ES: "y",
        PT: "e",
        FI: "ja",
        SV: "och",
        NO: "og",
    },
    or: {
        EN: "or",
        DA: "eller",
        DE: "oder",
        NL: "of",
        FR: "ou",
        IT: "o",
        ES: "o",
        PT: "ou",
        FI: "tai",
        SV: "eller",
        NO: "eller",
    },
    "no-thanks": {
        EN: "No thanks",
        DA: "Nej tak",
        DE: "Nein danke",
        NL: "Nee bedankt",
        FR: "Non merci",
        IT: "No grazie",
        ES: "No gracias",
        PT: "Não obrigado",
        FI: "Ei kiitos",
        SV: "Nej tack",
        NO: "Nei takk",
    },
    items: {
        EN: "Items",
        DA: "Varer",
        DE: "Artikel",
        NL: "Artikelen",
        FR: "Articles",
        IT: "Articoli",
        ES: "Artículos",
        PT: "Artigos",
        FI: "Tuotteet",
        SV: "Produkter",
        NO: "Varer",
    },
    shipping: {
        EN: "Shipping",
        DA: "Forsendelse",
        DE: "Versand",
        NL: "Verzending",
        FR: "Expédition",
        IT: "Spedizione",
        ES: "Envío",
        PT: "Envio",
        FI: "Palautustapa",
        SV: "Returmetod",
        NO: "Frakt",
    },
    confirm: {
        EN: "Confirm",
        DA: "Bekræft",
        DE: "Bestätigen",
        NL: "Bevestigen",
        FR: "Confirmer",
        IT: "Conferma",
        ES: "Confirmar",
        PT: "Confirmar",
        FI: "Vahvista",
        SV: "Bekräfta",
        NO: "Bekreft",
    },
    total: {
        EN: "Total",
        DA: "Total",
        DE: "Gesamt",
        NL: "Totaal",
        FR: "Total",
        IT: "Totale",
        ES: "Total",
        PT: "Total",
        FI: "Yhteensä",
        SV: "Total",
        NO: "Total",
    },
    "purchase-date": {
        EN: "Purchase date",
        DA: "Købsdato",
        DE: "Kaufdatum",
        NL: "Aankoopdatum",
        FR: "Date d'achat",
        IT: "Data di acquisto",
        ES: "Fecha de compra",
        PT: "Data de compra",
        FI: "Ostopäivä",
        SV: "Orderdatum",
        NO: "Ordredato",
    },
    "return-period": {
        EN: "Return period",
        DA: "Returperiode",
        DE: "Rückgabefrist",
        NL: "Retourperiode",
        FR: "Période de retour",
        IT: "Periodo di reso",
        ES: "Período de devolución",
        PT: "Período de devolução",
        FI: "Palautusaika",
        SV: "Returperiod",
        NO: "Returperiode",
    },
    "return-period.withdrawal": {
        EN: "Withdrawal period",
        DA: "Fortrydelsesret",
        DE: "Widerrufsfrist",
        NL: "Herroepingstermijn",
        FR: "Délai de rétractation",
        IT: "Periodo di recesso",
        ES: "Plazo de desistimiento",
        PT: "Prazo de desistência",
        FI: "Peruutusaika",
        SV: "Ångerrätt",
        NO: "Angrerett",
    },
    "days-remaining": {
        EN: "Days remaining",
        DA: "Dage tilbage",
        DE: "Verbleibende Tage",
        NL: "Dagen resterend",
        FR: "Jours restants",
        IT: "Giorni rimanenti",
        ES: "Días restantes",
        PT: "Dias restantes",
        FI: "Päiviä jäljellä",
        SV: "Dagar kvar",
        NO: "Dager igjen",
    },
    "no-days-remaining": {
        EN: "No days remaining",
        DA: "Ingen dage tilbage",
        DE: "Keine Tage übrig",
        NL: "Geen dagen resterend",
        FR: "Aucun jour restant",
        IT: "Nessun giorno rimanente",
        ES: "No quedan días",
        PT: "Sem dias restantes",
        FI: "Ei päiviä jäljellä",
        SV: "Inga dagar kvar",
        NO: "Ingen dager igjen",
    },
    purchased: {
        EN: "Purchased",
        DA: "Købt",
        DE: "Gekauft",
        NL: "Gekocht",
        FR: "Acheté",
        IT: "Acquistato",
        ES: "Comprado",
        PT: "Comprado",
        FI: "Ostettu",
        SV: "Köpt",
        NO: "Kjøpt",
    },
    continue: {
        EN: "Continue",
        DA: "Fortsæt",
        DE: "Weiter",
        NL: "Doorgaan",
        FR: "Continuer",
        IT: "Continua",
        ES: "Continuar",
        PT: "Continuar",
        FI: "Jatka",
        SV: "Fortsätt",
        NO: "Fortsett",
    },
    EXCHANGE: {
        EN: "Exchange",
        DA: "Ombytning",
        DE: "Umtausch",
        NL: "Ruilen",
        FR: "Échange",
        IT: "Cambio",
        ES: "Cambio",
        PT: "Troca",
        FI: "Vaihto",
        SV: "Byte",
        NO: "Bytte",
    },
    RETURN: {
        EN: "Return",
        DA: "Retur",
        DE: "Rückgabe",
        NL: "Retour",
        FR: "Retour",
        IT: "Reso",
        ES: "Devolución",
        PT: "Devolução",
        FI: "Palautus",
        SV: "Retur",
        NO: "Retur",
    },
    WITHDRAWAL: {
        EN: "Withdrawal",
        DA: "Fortrydelse",
        DE: "Widerruf",
        NL: "Herroeping",
        FR: "Rétractation",
        IT: "Recesso",
        ES: "Desistimiento",
        PT: "Desistência",
        FI: "Peruutus",
        SV: "Ångerrätt",
        NO: "Angrerett",
    },
    COMPLAINT: {
        EN: "Complaint",
        DA: "Reklamation",
        DE: "Reklamation",
        NL: "Klacht",
        FR: "Réclamation",
        IT: "Reclamo",
        ES: "Reclamación",
        PT: "Reclamação",
        FI: "Reklamaatio",
        SV: "Reklamation",
        NO: "Klage",
    },
    RESALE: {
        EN: "Resale",
        DA: "Videresalg",
        DE: "Wiederverkauf",
        NL: "Doorverkoop",
        FR: "Revente",
        IT: "Rivendita",
        ES: "Reventa",
        PT: "Revenda",
        FI: "Jälleenmyynti",
        SV: "Återförsäljning",
        NO: "Videresalg",
    },
    loading: {
        EN: "Loading...",
        DA: "Indlæser...",
        DE: "Lädt...",
        NL: "Laden...",
        FR: "Chargement...",
        IT: "Caricamento...",
        ES: "Cargando...",
        PT: "Carregando...",
        FI: "Ladataan...",
        SV: "Laddar…",
        NO: "Laster…",
    },
    order: {
        EN: "Order",
        DA: "Ordre",
        DE: "Bestellung",
        NL: "Bestelling",
        FR: "Commande",
        IT: "Ordine",
        ES: "Pedido",
        PT: "Pedido",
        FI: "Tilaus",
        SV: "Order",
        NO: "Bestilling",
    },
    orderId: {
        EN: "Order ID",
        DA: "Ordre-id",
        DE: "Bestell-ID",
        NL: "Bestelnummer",
        FR: "ID de commande",
        IT: "ID ordine",
        ES: "ID de pedido",
        PT: "ID do pedido",
        FI: "Tilausnumero",
        SV: "Order-ID",
        NO: "Ordre-ID",
    },
    change: {
        EN: "Change",
        DA: "Rediger",
        DE: "Ändern",
        NL: "Wijzigen",
        FR: "Modifier",
        IT: "Cambia",
        ES: "Cambiar",
        PT: "Alterar",
        FI: "Muokkaa",
        SV: "Ändra",
        NO: "Endre",
    },
    save: {
        EN: "Save",
        DA: "Gem",
        DE: "Speichern",
        NL: "Opslaan",
        FR: "Enregistrer",
        IT: "Salva",
        ES: "Guardar",
        PT: "Salvar",
        FI: "Tallenna",
        SV: "Spara",
        NO: "Lagre",
    },
    "confirmation-email.label": {
        EN: "Confirmation email",
        DA: "Bekræftelses-e-mail",
        DE: "Bestätigungs-E-Mail",
        NL: "Bevestigingse-mail",
        FR: "E-mail de confirmation",
        IT: "Email di conferma",
        ES: "Correo de confirmación",
        PT: "E-mail de confirmação",
        FI: "Vahvistussähköposti",
        SV: "Bekräftelsemail",
        NO: "Bekreftelses-e-post",
    },
    "confirmation-email.description": {
        EN: "We will send confirmation of your withdrawal to this email.",
        DA: "Vi sender bekræftelse på din fortrydelse til denne e-mail.",
        DE: "Wir senden eine Bestätigung deines Widerrufs an diese E-Mail-Adresse.",
        NL: "We sturen een bevestiging van uw herroeping naar dit e-mailadres.",
        FR: "Nous enverrons une confirmation de votre rétractation à cette adresse e-mail.",
        IT: "Invieremo la conferma del tuo recesso a questo indirizzo email.",
        ES: "Enviaremos la confirmación de tu desistimiento a este correo electrónico.",
        PT: "Enviaremos a confirmação da sua desistência para este e-mail.",
        FI: "Lähetämme vahvistuksen peruutuksestasi tähän sähköpostiosoitteeseen.",
        SV: "Vi skickar en bekräftelse på din ångerrätt till denna e-postadress.",
        NO: "Vi sender en bekreftelse på angreretten din til denne e-postadressen.",
    },
    "weekdays.0": {
        EN: "Sunday",
        DA: "Søndag",
        DE: "Sonntag",
        NL: "Zondag",
        FR: "Dimanche",
        IT: "Domenica",
        ES: "Domingo",
        PT: "Domingo",
        FI: "Sunnuntai",
        SV: "Söndag",
        NO: "Søndag",
    },
    "weekdays.1": {
        EN: "Monday",
        DA: "Mandag",
        DE: "Montag",
        NL: "Maandag",
        FR: "Lundi",
        IT: "Lunedì",
        ES: "Lunes",
        PT: "Segunda-feira",
        FI: "Maanantai",
        SV: "Måndag",
        NO: "Mandag",
    },
    "weekdays.2": {
        EN: "Tuesday",
        DA: "Tirsdag",
        DE: "Dienstag",
        NL: "Dinsdag",
        FR: "Mardi",
        IT: "Martedì",
        ES: "Martes",
        PT: "Terça-feira",
        FI: "Tiistai",
        SV: "Tisdag",
        NO: "Tirsdag",
    },
    "weekdays.3": {
        EN: "Wednesday",
        DA: "Onsdag",
        DE: "Mittwoch",
        NL: "Woensdag",
        FR: "Mercredi",
        IT: "Mercoledì",
        ES: "Miércoles",
        PT: "Quarta-feira",
        FI: "Keskiviikko",
        SV: "Onsdag",
        NO: "Onsdag",
    },

    "weekdays.4": {
        EN: "Thursday",
        DA: "Torsdag",
        DE: "Donnerstag",
        NL: "Donderdag",
        FR: "Jeudi",
        IT: "Giovedì",
        ES: "Jueves",
        PT: "Quinta-feira",
        FI: "Torstai",
        SV: "Torsdag",
        NO: "Torsdag",
    },
    "weekdays.5": {
        EN: "Friday",
        DA: "Fredag",
        DE: "Freitag",
        NL: "Vrijdag",
        FR: "Vendredi",
        IT: "Venerdì",
        ES: "Viernes",
        PT: "Sexta-feira",
        FI: "Perjantai",
        SV: "Fredag",
        NO: "Fredag",
    },

    "weekdays.6": {
        EN: "Saturday",
        DA: "Lørdag",
        DE: "Samstag",
        NL: "Zaterdag",
        FR: "Samedi",
        IT: "Sabato",
        ES: "Sábado",
        PT: "Sábado",
        FI: "Lauantai",
        SV: "Lördag",
        NO: "Lørdag",
    },
    "weekdays-short.0": {
        EN: "Sun",
        DA: "Søn",
        DE: "So",
        NL: "Zo",
        FR: "Dim",
        IT: "Dom",
        ES: "Dom",
        PT: "Dom",
        FI: "Su",
        SV: "Sön",
        NO: "Søn",
    },
    "weekdays-short.1": {
        EN: "Mon",
        DA: "Man",
        DE: "Mo",
        NL: "Ma",
        FR: "Lun",
        IT: "Lun",
        ES: "Lun",
        PT: "Seg",
        FI: "Ma",
        SV: "Mån",
        NO: "Man",
    },
    "weekdays-short.2": {
        EN: "Tue",
        DA: "Tir",
        DE: "Di",
        NL: "Di",
        FR: "Mar",
        IT: "Mar",
        ES: "Mar",
        PT: "Ter",
        FI: "Ti",
        SV: "Tis",
        NO: "Tir",
    },
    "weekdays-short.3": {
        EN: "Wed",
        DA: "Ons",
        DE: "Mi",
        NL: "Wo",
        FR: "Mer",
        IT: "Mer",
        ES: "Mié",
        PT: "Qua",
        FI: "Ke",
        SV: "Ons",
        NO: "Ons",
    },
    "weekdays-short.4": {
        EN: "Thu",
        DA: "Tor",
        DE: "Do",
        NL: "Do",
        FR: "Jeu",
        IT: "Gio",
        ES: "Jue",
        PT: "Qui",
        FI: "To",
        SV: "Tor",
        NO: "Tor",
    },
    "weekdays-short.5": {
        EN: "Fri",
        DA: "Fre",
        DE: "Fr",
        NL: "Vr",
        FR: "Ven",
        IT: "Ven",
        ES: "Vie",
        PT: "Sex",
        FI: "Pe",
        SV: "Fre",
        NO: "Fre",
    },
    "weekdays-short.6": {
        EN: "Sat",
        DA: "Lør",
        DE: "Sa",
        NL: "Za",
        FR: "Sam",
        IT: "Sab",
        ES: "Sáb",
        PT: "Sáb",
        FI: "La",
        SV: "Lör",
        NO: "Lør",
    },

    "months.0": {
        EN: "January",
        DA: "Januar",
        DE: "Januar",
        NL: "Januari",
        FR: "Janvier",
        IT: "Gennaio",
        ES: "Enero",
        PT: "Janeiro",
        FI: "Tammikuu",
        SV: "Januari",
        NO: "Januar",
    },
    "months.1": {
        EN: "February",
        DA: "Februar",
        DE: "Februar",
        NL: "Februari",
        FR: "Février",
        IT: "Febbraio",
        ES: "Febrero",
        PT: "Fevereiro",
        FI: "Helmikuu",
        SV: "Februari",
        NO: "Februar",
    },
    "months.2": {
        EN: "March",
        DA: "Marts",
        DE: "März",
        NL: "Maart",
        FR: "Mars",
        IT: "Marzo",
        ES: "Marzo",
        PT: "Março",
        FI: "Maaliskuu",
        SV: "Mars",
        NO: "Mars",
    },
    "months.3": {
        EN: "April",
        DA: "April",
        DE: "April",
        NL: "April",
        FR: "Avril",
        IT: "Aprile",
        ES: "Abril",
        PT: "Abril",
        FI: "Huhtikuu",
        SV: "April",
        NO: "April",
    },
    "months.4": {
        EN: "May",
        DA: "Maj",
        DE: "Mai",
        NL: "Mei",
        FR: "Mai",
        IT: "Maggio",
        ES: "Mayo",
        PT: "Maio",
        FI: "Toukokuu",
        SV: "Maj",
        NO: "Mai",
    },
    "months.5": {
        EN: "June",
        DA: "Juni",
        DE: "Juni",
        NL: "Juni",
        FR: "Juin",
        IT: "Giugno",
        ES: "Junio",
        PT: "Junho",
        FI: "Kesäkuu",
        SV: "Juni",
        NO: "Juni",
    },
    "months.6": {
        EN: "July",
        DA: "Juli",
        DE: "Juli",
        NL: "Juli",
        FR: "Juillet",
        IT: "Luglio",
        ES: "Julio",
        PT: "Julho",
        FI: "Heinäkuu",
        SV: "Juli",
        NO: "Juli",
    },
    "months.7": {
        EN: "August",
        DA: "August",
        DE: "August",
        NL: "Augustus",
        FR: "Août",
        IT: "Agosto",
        ES: "Agosto",
        PT: "Agosto",
        FI: "Elokuu",
        SV: "Augusti",
        NO: "August",
    },
    "months.8": {
        EN: "September",
        DA: "September",
        DE: "September",
        NL: "September",
        FR: "Septembre",
        IT: "Settembre",
        ES: "Septiembre",
        PT: "Setembro",
        FI: "Syyskuu",
        SV: "September",
        NO: "September",
    },
    "months.9": {
        EN: "October",
        DA: "Oktober",
        DE: "Oktober",
        NL: "Oktober",
        FR: "Octobre",
        IT: "Ottobre",
        ES: "Octubre",
        PT: "Outubro",
        FI: "Lokakuu",
        SV: "Oktober",
        NO: "Oktober",
    },
    "months.10": {
        EN: "November",
        DA: "November",
        DE: "November",
        NL: "November",
        FR: "Novembre",
        IT: "Novembre",
        ES: "Noviembre",
        PT: "Novembro",
        FI: "Marraskuu",
        SV: "November",
        NO: "November",
    },
    "months.11": {
        EN: "December",
        DA: "December",
        DE: "Dezember",
        NL: "December",
        FR: "Décembre",
        IT: "Dicembre",
        ES: "Diciembre",
        PT: "Dezembro",
        FI: "Joulukuu",
        SV: "December",
        NO: "Desember",
    },
    "months-short.0": {
        EN: "Jan",
        DA: "Jan",
        DE: "Jan",
        NL: "Jan",
        FR: "janv.",
        IT: "Gen",
        ES: "Ene",
        PT: "Jan",
        FI: "Tammi",
        SV: "Jan",
        NO: "Jan",
    },
    "months-short.1": {
        EN: "Feb",
        DA: "Feb",
        DE: "Feb",
        NL: "Feb",
        FR: "févr.",
        IT: "Feb",
        ES: "Feb",
        PT: "Fev",
        FI: "Helmi",
        SV: "Feb",
        NO: "Feb",
    },
    "months-short.2": {
        EN: "Mar",
        DA: "Mar",
        DE: "Mär",
        NL: "Mrt",
        FR: "mars",
        IT: "Mar",
        ES: "Mar",
        PT: "Mar",
        FI: "Maalis",
        SV: "Mar",
        NO: "Mar",
    },
    "months-short.3": {
        EN: "Apr",
        DA: "Apr",
        DE: "Apr",
        NL: "Apr",
        FR: "avr.",
        IT: "Apr",
        ES: "Abr",
        PT: "Abr",
        FI: "Huhti",
        SV: "Apr",
        NO: "Apr",
    },
    "months-short.4": {
        EN: "May",
        DA: "Maj",
        DE: "Mai",
        NL: "Mei",
        FR: "mai",
        IT: "Mag",
        ES: "May",
        PT: "Mai",
        FI: "Touko",
        SV: "Maj",
        NO: "Mai",
    },
    "months-short.5": {
        EN: "Jun",
        DA: "Jun",
        DE: "Jun",
        NL: "Jun",
        FR: "juin",
        IT: "Giu",
        ES: "Jun",
        PT: "Jun",
        FI: "Kesä",
        SV: "Jun",
        NO: "Jun",
    },
    "months-short.6": {
        EN: "Jul",
        DA: "Jul",
        DE: "Jul",
        NL: "Jul",
        FR: "juil.",
        IT: "Lug",
        ES: "Jul",
        PT: "Jul",
        FI: "Heinä",
        SV: "Jul",
        NO: "Jul",
    },
    "months-short.7": {
        EN: "Aug",
        DA: "Aug",
        DE: "Aug",
        NL: "Aug",
        FR: "août",
        IT: "Ago",
        ES: "Ago",
        PT: "Ago",
        FI: "Elo",
        SV: "Aug",
        NO: "Aug",
    },
    "months-short.8": {
        EN: "Sep",
        DA: "Sep",
        DE: "Sep",
        NL: "Sep",
        FR: "sept.",
        IT: "Set",
        ES: "Sep",
        PT: "Set",
        FI: "Syys",
        SV: "Sep",
        NO: "Sep",
    },
    "months-short.9": {
        EN: "Oct",
        DA: "Okt",
        DE: "Okt",
        NL: "Okt",
        FR: "oct.",
        IT: "Ott",
        ES: "Oct",
        PT: "Out",
        FI: "Loka",
        SV: "Okt",
        NO: "Okt",
    },
    "months-short.10": {
        EN: "Nov",
        DA: "Nov",
        DE: "Nov",
        NL: "Nov",
        FR: "nov.",
        IT: "Nov",
        ES: "Nov",
        PT: "Nov",
        FI: "Marras",
        SV: "Nov",
        NO: "Nov",
    },
    "months-short.11": {
        EN: "Dec",
        DA: "Dec",
        DE: "Dez",
        NL: "Dec",
        FR: "Déc",
        IT: "Dic",
        ES: "Dic",
        PT: "Dez",
        FI: "Joulu",
        SV: "Dec",
        NO: "Des",
    },
    returning: {
        EN: "Returning",
        EN_TR: "Sending back",
        DA: "Returnerer",
        DE: "Zurücksenden",
        NL: "Retourneren",
        FR: "Retourner",
        IT: "Restituire",
        ES: "Devolviendo",
        PT: "Devolver",
        FI: "Palautetaan",
        SV: "Returnerar",
        NO: "Returnerer",
    },
    getting: {
        EN: "Getting",
        EN_TR: "Exchange to",
        DA: "Bytte til",
        DE: "Tauschen gegen",
        NL: "Ruilen naar",
        FR: "Échanger contre",
        IT: "Cambiare in",
        ES: "Cambiar por",
        PT: "Trocar por",
        FI: "Vaihdetaan",
        SV: "Byt till",
        NO: "Bytte til",
    },
    price: {
        EN: "Price",
        DA: "Pris",
        DE: "Preis",
        NL: "Prijs",
        FR: "Prix",
        IT: "Prezzo",
        ES: "Precio",
        PT: "Preço",
        FI: "Hinta",
        SV: "Pris",
        NO: "Pris",
    },
    "out-of-stock": {
        EN: "Out of stock",
        DA: "Ikke på lager",
        DE: "Nicht vorrätig",
        NL: "Niet op voorraad",
        FR: "Rupture de stock",
        IT: "Esaurito",
        ES: "Agotado",
        PT: "Fora de estoque",
        FI: "Loppuunmyyty",
        SV: "Slut i lager",
        NO: "Utsolgt",
    },

    "exchange-custom-message": {
        EN: "",
        DA: "",
        DE: "",
        NL: "",
        FR: "",
        IT: "",
        ES: "",
        PT: "",
        FI: "",
    },
};
export default texts;
